import EventHandler from './EventHandler';
import Socket from './mainSocket';

class GlobalSocket extends Socket {
	initialize(params, onSocketConnected, handleSocketData) {
		this.shouldReconnect = true;
		const eventHandler = new EventHandler();
		eventHandler.set_event_handler(handleSocketData);

		this.add_event_handler(eventHandler);
		this.connect_socket({ params, onSocketConnected });
	}
}

const globalSocket = new GlobalSocket();
export default globalSocket;
